import FormantNode from './FormantNode.js';
import Tone from 'tone';

const NUMBER_FORMANTS = 6;

export default class Formants {
    constructor(oscillator) {
        this.oscillator = oscillator;
        this.input = new Tone.Gain(0.3);
        this.output = new Tone.Gain(1);
        this.input.connect(this.output);

        this.formants = [];
        for (let i=0; i < NUMBER_FORMANTS; i++) {
            this.formants.push(new FormantNode(this, i));
        }
    }

    dispose() {
        this.formants.forEach(f => f.dispose());
    }

    anyFormantsOn() {
        return this.formants.some(
            f => f.enabled);
    }

    numFormants() {
        return this.formants.filter(
            f => f.enabled).length;
    }

    enableFormants() {
        // signal will now only go from input, through
        // formants and then the output
        this.input.disconnect(this.output);
    }

    disableFormants() {
        // signal will bypass the formants, going directly
        // from input to output
        this.input.connect(this.output);
    }
}
